module.exports = __webpack_public_path__ + "public/img/unmer-bg.8226b04b.png";